import React from 'react'
import { hasPerfil, PERFIL_ADMIN, getGestorEmpresa, getAdminEmpresa } from './securityContext'

// eslint-disable-next-line react/display-name
export default (props) => {
  let perfisHabilitados = [];
  let somenteTurismo = false;
  
  if (props.perfisPermitidos) {
    perfisHabilitados = props.perfisPermitidos
  }

  const permitido = perfisHabilitados.some(
    perfil => hasPerfil(perfil)
  );

  if(props.empresaSelecionada) {
    somenteTurismo = (!props.empresaSelecionada.rodoviario && props.empresaSelecionada.turismo) && !validaPerfis([PERFIL_ADMIN]) ? true : false;
  }

  if (permitido && !somenteTurismo && !props.turismo) {
    return (
      <React.Fragment>
        {props.children}
      </React.Fragment>
    )
  }

  if (permitido && props.empresaSelecionada.turismo == props.turismo) {
    return (
      <React.Fragment>
        {props.children}
      </React.Fragment>
    )
  }

  return ''
}

export function validaPerfis (perfis) {
  if (perfis && perfis.length) {
    const permitido = perfis.some(
      perfil => hasPerfil(perfil)
    );
    if (permitido) {
      return true
    }
  }
  return false
}

// Admin Vexado, Gestor Empresa e Admin Empresa podem imprimir ou
// reimprimir o bilhete mesmo apos a reserva ja ter sido embarcada
// (dataHoraEmbarque preenchida). Usar sempre em OU (||) com a
// condicao de dataHoraEmbarque que ja existe em cada tela — nunca
// substituir essa condicao.
export function podeImprimirBilheteAposEmbarque (idEmpresa) {
  return validaPerfis([
    PERFIL_ADMIN,
    getGestorEmpresa(idEmpresa),
    getAdminEmpresa(idEmpresa)
  ])
}
